<script lang="ts" setup>
import { onMounted } from 'vue';
import { PageHero } from '~/components';
import { AppBreadcrumbs, AppTypography } from '~/components/base';
import useGetTermsOfUse from '~/composables/useGetTermsOfUse';
import TermsOfUsePageContent from '~/utils/contents/pages/TermsOfUsePage';

definePageMeta({
  auth: false,
});

useHead({
  title: TermsOfUsePageContent.seo.title,
});

const breadcrumbs = [
  { label: 'About', to: '/support' },
  { label: 'Terms of Service' },
];

const { termsOfUse, lastUpdated, getTermsOfUse } = useGetTermsOfUse();

onMounted(() => {
  getTermsOfUse();
});
</script>

<template>
  <div class="terms-of-use-page">
    <PageHero constrained max-width="max-w-3xl">
      <AppBreadcrumbs
        :custom-breadcrumbs="breadcrumbs"
        class="hidden px-0 lg:flex"
      />

      <div class="terms-of-use-page__content">
        <AppTypography type="title-1" class="mb-6 text-left lg:text-center">
          {{ TermsOfUsePageContent.title }}
        </AppTypography>
        <AppTypography
          v-if="lastUpdated"
          type="footnote"
          class="text-color-tertiary mb-4"
        >
          Last updated: {{ lastUpdated }}
        </AppTypography>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="termsOfUse"></div>
      </div>
    </PageHero>
  </div>
</template>

<style lang="scss" scoped>
.terms-of-use-page {
  &__content {
    @media (min-width: 1024px) {
      padding: $spacing-5xl;
      border-radius: $radius-2xl;
      background-color: $surface-color-bg;
    }

    // The CMS content is authored with Filament's RichEditor (bold, italic,
    // underline, strike, sub/superscript, links, headings, lists,
    // blockquote, inline/block code, table) and rendered here via v-html —
    // see the rich-text-content mixin for why this override is needed.
    @include rich-text-content;
  }
}
</style>
